import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch, Redirect } from "react-router-dom";

import { Sidebar } from "components";

import dashboardRoutes from "routes/dashboard.jsx";
import { ToastContainer } from "react-toastify";
import ErrorBoundary from "../../views/Components/Common/ErrorBoundariesComponent";
import { withRouter } from "react-router-dom";
import compose from "compose-function";
import { connect } from "react-redux";

var ps;

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.mainPanelRef = React.createRef();
  }

  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1 && this.mainPanelRef.current) {
      document.documentElement.className += " perfect-scrollbar-on";
      document.documentElement.classList.remove("perfect-scrollbar-off");
      ps = new PerfectScrollbar(this.mainPanelRef.current);
    }
    if (!localStorage.getItem("authToken")) {
      this.props.history.push("/pages/login-page");
    }
  }

  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      if (ps) {
        ps.destroy();
      }
      document.documentElement.className += " perfect-scrollbar-off";
      document.documentElement.classList.remove("perfect-scrollbar-on");
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.history.action === "PUSH") {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;

      if (this.mainPanelRef.current) {
        this.mainPanelRef.current.scrollTop = 0;
      }
    }
  }

  render() {
    return (
      <div className="wrapper">
        <Sidebar {...this.props} routes={dashboardRoutes} />
        <div className="main-panel" ref={this.mainPanelRef}>
          {
            //<Header {...this.props} />
          }
          {/** <StickyHeader header={<NewHeader {...this.props} />} />
         <div className="container-fluid headerpic-div"> <HeaderImage /></div> */}
          <div className="container" id="page-content-wrapper">
            <ErrorBoundary>
              <Switch>
                {dashboardRoutes.map((prop, key) => {
                  if (prop.collapse) {
                    return prop.views.map((prop2, key2) => {
                      return (
                        <Route
                          path={prop2.path}
                          component={prop2.component}
                          key={key2}
                        />
                      );
                    });
                  }
                  if (prop.redirect)
                    return (
                      <Redirect from={prop.path} to={prop.pathTo} key={key} />
                    );
                  return (
                    <Route
                      path={prop.path}
                      component={prop.component}
                      key={key}
                    />
                  );
                })}
              </Switch>
            </ErrorBoundary>
          </div>
          <ToastContainer />
          {/* {// we don't want the Footer to be rendered on full screen maps page
          this.props.location.pathname.indexOf("full-screen-maps") !==
          -1 ? null : (
            <Footer fluid />
          )}*/}
        </div>
      </div>
    );
  }
}

//export default Dashboard;
export default compose(withRouter, connect())(Dashboard);
